<template>
  <main-layout>
    <v-container class="partner-container">
      <h1>{{ $t('Plugin') }}</h1>
      <div class="mt-3">
        <v-btn
          :outline="currentView == 'partner' ? false : true"
          color="primary"
          small
          @click="changeView('partner')"
        >
          {{ $t('PARTNER') }}
        </v-btn>
        <v-btn
          :outline="currentView == 'zerva_connect' ? false : true"
          color="primary"
          small
          @click="changeView('zerva_connect')"
        >
          {{ $t('CONNECT ZERVA') }}
        </v-btn>
      </div>

      <div class="mt-2">
        <div style="padding: 30px; background: #fff; border-radius: 30px;">
          <template v-if="currentView === 'partner'">
            <h2>{{ $t('Integrated Partner') }}</h2>
            <template>
              <template>
                <v-container v-if="selectedBot">
                  <line-my-shop-manage></line-my-shop-manage>
                </v-container>
                <v-divider />
              </template>
              <v-container>
                <chatday></chatday>
              </v-container>
              <template v-if="selectedBot.theme == 'ecommercebasic'">
                <v-divider class="my-3"></v-divider>
                <v-container>
                  <ketshop-setting></ketshop-setting>
                </v-container>
              </template>
              <template
                v-if="
                  [
                    '110031921236093',
                    '107279640884439',
                    '103195847822433',
                    '101988825306603',
                    '106399168069722',
                    '110595987937972',
                    '108023541529835',
                    '111430097698951',
                    '107412714352011'
                  ].includes(selectedBot.pageid)
                "
              >
                <v-divider class="my-3"></v-divider>
                <v-container>
                  <egg-digital></egg-digital>
                </v-container>
              </template>
            </template>
          </template>
          <zerva-connect v-else-if="currentView === 'zerva_connect'" />
        </div>
      </div>
    </v-container>
  </main-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import KetshopSetting from '@/components/view/billing/KetshopSetting'
import EggDigital from '@/components/view/billing/EggDigital'
import Chatday from '@/components/view/billing/Chatday'
import LineMyShopManage from '@/components/view/billing/LineMyShopManage'
import ZervaConnect from '@/components/view/ZervaConnect'

export default {
  components: {
    Chatday,
    KetshopSetting,
    EggDigital,
    LineMyShopManage,
    ZervaConnect
  },
  mounted() {
    const { plugin } = this.$route.query

    if (plugin) {
      this.currentView = plugin
    }
  },
  data() {
    return {
      currentView: 'partner'
    }
  },
  methods: {
    changeView(view) {
      this.$router.replace({ query: { plugin: view } })
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 959px) {
  .container {
    width: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/partner/PartnerView.vue